import { ThemeMode } from '../types';

const THEME_STORAGE_KEY = 'vestibular_theme';

export function getStoredTheme(): ThemeMode {
  const shared = document.cookie.match(/(?:^|;\s*)_nixlabs_theme=(light|dark)/)?.[1];
  if (shared) return shared === 'dark' ? 'dark' : 'off-white';
  const local = localStorage.getItem(THEME_STORAGE_KEY);
  if (local === 'dark' || local === 'off-white') return local;
  return 'off-white';
}

export function applyTheme(theme: ThemeMode) {
  const root = document.documentElement;
  root.setAttribute('data-theme', theme === 'dark' ? 'dark' : 'light');
  if (theme === 'dark') {
    root.classList.add('dark');
    root.style.colorScheme = 'dark';
  } else {
    root.classList.remove('dark');
    root.style.colorScheme = 'light';
  }
}

export async function persistTheme(theme: ThemeMode, isAuthenticated: boolean) {
  localStorage.setItem(THEME_STORAGE_KEY, theme);
  applyTheme(theme);

  if (isAuthenticated) {
    try {
      await fetch('/api/user/theme', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ theme }),
      });
    } catch {
      // offline or silent fail
    }
  }
}
